import React from 'react'
import { useCallback, useState, useRef, useEffect, useMemo, RefObject } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { NavBar } from '../../components/layout/NavBar';
import './Machines.module.css'
import { Services } from '@/services/services';
import { Translates } from '@/services/repository/i18n';
import { useForm } from 'react-hook-form';
import { MachineForm, FormData, FormErrors } from './Machines.form';
import { Machine } from '@/services/model/machine';

export const MachinesPage = ({ services }: { services: Services }) => {
  const companyId = Number(useParams().cid)
  const navigate = useNavigate();
  const [list, setList] = useState<Machine[] | null>()
  const [translates, setTranslates] = useState<Translates>()
  const [serverErrors, setServerErrors] = useState<FormErrors<FormData>>()
  const form = useForm<FormData>()

  function refreshList() {
    services.machines.byCompany(companyId).then((data) => setList(data || []))
  }

  const onSubmit = async (data: FormData, resetForm: () => void) => {
    data.companyId = companyId
    const resp = await fetch('/api/schema/machines/new', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data),
    })
    if (!resp.ok) {
      setServerErrors(await resp.json())
    } else {
      refreshList()
      resetForm()
    }
  }

  useEffect(() => {
    services.i18n.get('main').then(setTranslates)
  }, [])

  useEffect(() => {
    refreshList()
  }, [])

  function renderRow(row: Machine) {
    return (<li>
      <span onClick={() => navigate(`/machines/${row.id}`)}>{row.name}</span>
    </li>)
  }

  if (translates === undefined) {
    return (<div className='spinner'></div>)
  }

  return (
    <div>
      <NavBar services={services} />
      <section className='machines-page content-body'>
        <h2>{translates.for('page.machines.title')}</h2>
        <ul>
          {list !== null ? list?.map((row) => renderRow(row)) : (<div className='spinner'></div>)}
        </ul>

        <div className='main-form'>
          <div className='form-title'>{translates.for('page.machines.formTitle')}</div>
          <MachineForm
            form={form}
            services={services}
            onSubmit={onSubmit}
            serverErrors={serverErrors}
          />
        </div>
      </section>
    </div>
  );
};
